import PropTypes from 'prop-types'
import React from 'react'
import { Redirect, Route } from "react-router-dom";
import STSComponent from "../../../STSComponent/STSComponent"
import { returnNavigation } from '../../helpers'
import HeaderIcons from './components/HeaderIcons'
import { globals } from '../../../../globals';
import './css/IntranetHeader.scss'

class RedirectStateScapeLegacyLogout extends STSComponent {
  componentDidMount() {
    window.location.href = globals.servicesUrl + "/search/logoff.aspx?l=internal";
  }
  render() {
    return null;
  }
}

class IntranetHeader extends STSComponent {
  constructor (props) {
    super(props)
    this.state = {
      shutdown: false,
    }
  } 

  signOutLegacy = () => {
    localStorage.removeItem('authData')
    this.setState({ shutdown: true });
  }

  render () {
    const { permissions, location, showModal, authData, signOut } = this.props
    const { shutdown } = this.state

    if (shutdown) {         
      return <Route path="/" component={RedirectStateScapeLegacyLogout} /> 
    } else {
      return <div className="header-layout-wrap container-fluid">
      <div className="container-header">
        <a className="header-logo" href="http://www.statescape.com/" target="_blank" rel="noreferrer noopener">
          <div className="logo-short" />
        </a>
        <div className="nav-wrapper nav-width">
          <div className="header-links-section">
            {returnNavigation(permissions, location.pathname)}
          </div>
        </div>
        <HeaderIcons
          location={location.pathname}
          onClick={this.signOutLegacy}
          showModal={showModal}
          authData={authData}
        />
      </div>
      </div>      
    }
  }

  static propTypes = {
    permissions: PropTypes.array,
    location: PropTypes.object,
    showModal: PropTypes.func,
    signOut: PropTypes.func,
    authData: PropTypes.object
  }
}

export default IntranetHeader



// WEBPACK FOOTER //
// ./src/components/Header/components/IntranetSide/IntranetHeader.js